/**
 * cro-pdp.js — orchestration for the CRO V2 product page template.
 *
 * - <lazy-mount>: mounts its <template> children when scrolled near viewport.
 *                 Used to defer Judge.me reviews and other heavy widgets.
 * - Enhances the existing <cart-bar> with show/hide on scroll past ATC.
 * - Smooth-scroll for "Read all reviews" → reviews block.
 *
 * Loaded only on the CRO template.
 */
(function () {
  /* ---------- Lazy mount custom element ---------- */
  if (!customElements.get('lazy-mount')) {
    class LazyMount extends HTMLElement {
      constructor() {
        super();
        this.mounted = false;
      }

      connectedCallback() {
        var rootMargin = this.dataset.mountRootmargin || '600px';
        var trigger = this.querySelector('[data-lazy-mount-trigger]');

        if (trigger) {
          trigger.addEventListener('click', () => this.mount(), { once: true });
        }

        if ('IntersectionObserver' in window) {
          this._io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) this.mount();
            });
          }, { rootMargin: rootMargin });
          this._io.observe(this);
        } else {
          // Fallback: mount immediately
          this.mount();
        }
      }

      mount() {
        if (this.mounted) return;
        var tpl = this.querySelector('template');
        if (!tpl) return;
        var frag = tpl.content.cloneNode(true);
        // Replace template with content
        tpl.replaceWith(frag);
        this.dataset.mounted = 'true';
        this.mounted = true;
        if (this._io) this._io.disconnect();

        // If Judge.me's global script hasn't loaded yet, request it now.
        if (!document.querySelector('script[data-judgeme-loader]') && window.jdgm == null) {
          var s = document.createElement('script');
          s.src = 'https://cdn.judge.me/widget_preloader.js';
          s.async = true;
          s.dataset.judgemeLoader = '';
          document.head.appendChild(s);
        }

        this.dispatchEvent(new CustomEvent('lazy-mount:mounted', { bubbles: true }));
      }
    }
    customElements.define('lazy-mount', LazyMount);
  }

  /* ---------- Smooth-scroll for "Read all reviews" CTA ---------- */
  document.addEventListener('click', function (e) {
    var target = e.target.closest('[data-cro-scroll-to]');
    if (!target) return;
    var sel = target.getAttribute('data-cro-scroll-to');
    var dest = sel && document.querySelector(sel);
    if (!dest) return;
    e.preventDefault();
    dest.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------- Refresh price targets after CRO blocks render ----------
   * The cart-bar's <quantity-breaks> needs to know about the cart-bar price
   * span even though both elements live in different sections. We fire a
   * refresh once on load (after defer scripts execute) so cart-bar mirrors
   * any tier price the user already chose.
   */
  document.addEventListener('DOMContentLoaded', function () {
    var qb = document.querySelector('quantity-breaks');
    if (!qb) return;
    if (typeof qb.collectPriceTargets === 'function') {
      // Re-collect (cart-bar may have been added late)
      qb.priceTargets = qb.collectPriceTargets();
      var checked = qb.querySelector('[data-qb-input]:checked');
      if (checked && typeof qb.applyTier === 'function') {
        qb.applyTier(qb.optionForInput(checked));
      }
    }
  });
})();
